import { createStore, applyMiddleware, compose } from "redux";
import { batchedSubscribe } from "redux-batched-subscribe";
import thunk from "redux-thunk";
import logger from 'redux-logger';

// Load reducers
import rootReducer from '../reducers/index';

/**
 * Create a new store.
 * Apply middleware
 *
 */
const middleware = applyMiddleware(thunk);

const enhancer = compose(
    middleware,
    batchedSubscribe((notify) => {
      notify();
    })
)
const store = createStore(
    rootReducer,
    enhancer
  );

export default store;